// @ts-nocheck
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { initApiClient } from '@vestolio/app'
import { webStorage } from './lib/storage'
import { webNavigation } from './lib/navigation'
import App from './App.tsx'
import { ConfirmDialogProvider } from './components/common/ConfirmDialogProvider'
import './globals.css'

// Handle chunk load failures globally (stale deployments)
// Vite emits this event when a dynamic import's preloaded chunk fails to load
window.addEventListener('vite:preloadError', (event) => {
  const lastReload = Number(sessionStorage.getItem('chunk_reload_ts') || '0')
  if (Date.now() - lastReload > 60000) {
    sessionStorage.setItem('chunk_reload_ts', String(Date.now()))
    window.location.reload()
  }
})

// Also catch unhandled promise rejections for dynamic import failures
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('Failed to fetch dynamically imported module') ||
      event.reason?.message?.includes('Importing a module script failed')) {
    const lastReload = Number(sessionStorage.getItem('chunk_reload_ts') || '0')
    if (Date.now() - lastReload > 60000) {
      sessionStorage.setItem('chunk_reload_ts', String(Date.now()))
      window.location.reload()
    }
  }
})

// Initialize the shared API client with web-specific adapters
initApiClient({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4000/api/v1',
  storage: webStorage,
  navigation: webNavigation,
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ConfirmDialogProvider>
          <App />
        </ConfirmDialogProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)